import _ from 'lodash';
(function () {
    "use strict";
    var app = angular.module("skillBuilderSaaS");
    app.animation(".slide-panel", function () {
        return {
            enter: function (element, done) {
                var delay = element.data("delay");
                if (delay)
                    element.find(".panel").delay(delay);
                element.find(".panel").hide().slideDown(300, function () { done(); });
                element.fadeIn(300);
                return function (cancelled) {
                    if (cancelled)
                        element.stop();
                };
            },
            leave: function (element, done) {
                element.find(".panel").slideUp(300, function () { done(); });
                element.fadeOut(300);
                return function (isCancelled) {
                    if (isCancelled) {
                        element.stop();
                    }
                };
            }
        };
    })
        .animation(".slide-td", function () {
        return {
            enter: function (element, done) {
                var delay = element.data("delay");
                if (!delay)
                    delay = 0;
                element.delay(delay);
                var paddingTop = element.css("paddingTop");
                var paddingBottom = element.css("paddingBottom");
                element.css("paddingTop", 0);
                element.css("paddingBottom", 0);
                element
                    .wrapInner("<div />")
                    .children()
                    .hide()
                    .delay(delay)
                    .slideDown(200);
                element.hide()
                    .animate({ paddingTop: paddingTop, paddingBottom: paddingBottom })
                    .slideDown(200, function () { done(); });
                element.fadeIn(200);
                return function (cancelled) {
                    if (cancelled)
                        element.stop();
                };
            },
            leave: function (element, done) {
                element
                    .animate({ paddingTop: 0, paddingBottom: 0 })
                    .wrapInner("<div />")
                    .children()
                    .slideUp(200, function () { done(); });
                element.fadeOut(200);
                return function (isCancelled) {
                    if (isCancelled) {
                        element.stop();
                    }
                };
            }
        };
    })
        .controller("TenantRegistrationQuestionsModalCtrl", ["$scope", "$timeout", "tenantFeaturesResource", "frameworkService", "messageService", "question", "isPreregistration", tenantRegistrationQuestionsModalCtrl]);
    function tenantRegistrationQuestionsModalCtrl($scope, $timeout, tenantFeaturesResource, frameworkService, messageService, question, isPreregistration) {
        var vm = this;
        vm.loading = true;
        vm.animateLast = false;
        vm.showNewAnswerFields = false;
        vm.showErrors = false;
        vm.showErrorsNewAnswer = false;
        vm.isAdd = false;
        var enabledLocalizations = _.map(frameworkService.data.tenant.enabledLocalizations, function (item) {
            return {
                localizationId: item.id,
                localization: item
            };
        });
        vm.addAnswer = function () {
            vm.answerToEdit = null;
            vm.answerToEditData = null;
            vm.showNewAnswerFields = true;
            vm.newAnswer = {
                answerLocalizations: angular.copy(enabledLocalizations),
                enabled: true
            };
            $timeout(function () { angular.element("#newAnswerForm input").first().focus(); }, 700);
        };
        vm.editAnswer = function (answer) {
            if (vm.showNewAnswerFields) {
                vm.cancelAnswer();
            }
            vm.answerToEdit = answer;
            vm.answerToEditData = angular.copy(answer);
        };
        function load() {
            vm.onlyOneEnabled = !frameworkService.data.tenantFeatures.multiLanguage;
            if (question !== undefined) {
                vm.isAdd = false;
                tenantFeaturesResource.getTenantRegistrationQuestionViewModel({ actionValue: question.id }, function (result) {
                    vm.model = result;
                    vm.loading = false;
                }, function (error) {
                    messageService.error(error);
                });
            }
            else {
                vm.isAdd = true;
                vm.model = {
                    typeId: 0,
                    questionLocalizations: [],
                    answers: [],
                    isPreregistration: isPreregistration
                };
                angular.extend(vm.model.questionLocalizations, angular.copy(enabledLocalizations));
                vm.addAnswer();
                vm.loading = false;
            }
        }
        load();
        vm.saveAnswer = function (answer) {
            if (!vm.answerToEdit)
                return;
            if (vm.editAnswerForm["a" + answer.id].$valid) {
                answer.answerLocalizations = angular.copy(vm.answerToEditData.answerLocalizations);
                answer.enabled = vm.answerToEditData.enabled;
                answer.name = _.find(answer.answerLocalizations, { localizationId: parseInt(frameworkService.data.selectedLanguage.id.toString()) }).name;
                vm.answerToEditData = null;
                vm.answerToEdit = null;
            }
            else {
                vm.showErrorsEditAnswer = true;
            }
        };
        vm.saveNewAnswer = function (answer) {
            if (vm.newAnswerForm.$valid) {
                vm.animateLast = true;
                answer.name = _.find(answer.answerLocalizations, { localizationId: parseInt(frameworkService.data.selectedLanguage.id.toString()) }).name;
                vm.model.answers.push(answer);
                vm.newAnswer = {
                    answerLocalizations: angular.copy(enabledLocalizations),
                    enabled: true
                };
                vm.showErrorsNewAnswer = false;
                $timeout(function () { angular.element("#newAnswerForm input").first().focus(); }, 700);
            }
            else {
                vm.showErrorsNewAnswer = true;
            }
        };
        vm.deleteAnswer = function (answer) {
            if (answer.answerPicked)
                return;
            answer.removed = true;
            vm.answerToEditData = null;
            vm.answerToEdit = null;
        };
        vm.cancelAnswer = function () {
            vm.showNewAnswerFields = false;
            vm.answerToEdit = null;
            vm.answerToEditData = null;
        };
        vm.checkEscKey = function ($event) {
            if ($event.keyCode === 27 && vm.showNewAnswerFields) { //ESC
                vm.cancelAnswer();
                $event.stopPropagation();
            }
        };
        vm.sortableAnswers = {
            handle: ".cursor-move",
            axis: "y",
            start: function () {
                vm.animateLast = false;
            },
            stop: function () {
                vm.saveOrder();
            }
        };
        vm.saveOrder = function () {
            vm.animateLast = false;
            for (var i in vm.model.answers) {
                if (vm.model.answers.hasOwnProperty(i)) {
                    vm.model.answers[i].order = parseInt(i) + 1;
                }
            }
        };
        vm.save = function () {
            //Closes any open panel
            vm.cancelAnswer();
            $timeout(function () {
                if (vm.form.$valid) {
                    vm.saving = true;
                    tenantFeaturesResource.saveRegistrationQuestion(vm.model, function (result) {
                        vm.saving = false;
                        messageService.success("common.changesSaved");
                        $scope.$close(result);
                    }, function (error) {
                        console.error(error);
                        messageService.error(error);
                    });
                }
                else {
                    vm.showErrors = true;
                }
            });
        };
        vm.isLocalizationEnabled = function (localization) {
            return _.some(frameworkService.data.tenant.enabledLocalizations, function (item) {
                return item.id === localization.localizationId;
            });
        };
    }
})();
